/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import "./patch";
import React from "react";
import { EscalationMatrix } from "@innofulfill/escalation-matrix";
import "@innofulfill/escalation-matrix/dist/style.css";
import { APIs } from "../../utils/worker";

const EscalationMatrixView = () => {
    return (
        <div style={{ padding: "0px" }}>
            <EscalationMatrix baseUrl={`${APIs.baseURL}/v1/escalation-matrix`} />
        </div>
    );
};

export default EscalationMatrixView;
